var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon is-small",on:{"click":function($event){$event.preventDefault();return _vm.toggleValue()}}},[_c('i',{staticClass:"fa",class:'fa-' + (this.value ? this.icons.checked : this.icons.unchecked),attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5343a4b2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/toggle-buttons/icon-checkbox.vue
// module id = 526
// module chunks = 1